import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v27.3.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { J as e, o as r } from "./symbols.js";
import "@arcgis/core/symbols/support/jsonUtils";
import "@arcgis/core/renderers/support/jsonUtils";
import "moment";
import i from "natsort";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/Graphic";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";

var t = {
  autoPan: {
    edgeTolerance: 40,
    edgeToleranceFast: 15,
    insets: [{
      top: 0,
      right: 0,
      height: 82,
      width: 39
    }, {
      bottom: 0,
      right: 0,
      height: 89,
      width: 69
    }, {
      bottom: 0,
      right: 0,
      height: 16,
      width: "*"
    }],
    panDuration: 50,
    panPercentage: .3,
    panPercentageFast: .9,
    panRate: 5,
    startDelay: 500
  },
  clickTolerance: 4,
  defaultZoomLevel: 11,
  drawCircleOptions: {
    geodesic: !1,
    numberOfPoints: 60
  },
  drawOptions: {
    drawTime: 90,
    tolerance: 1,
    showTooltips: !1
  },
  drawTools: {
    areaUnits: {
      label: "ac",
      esriUnit: "acres"
    },
    lengthUnits: {
      label: "ft",
      esriUnit: "feet"
    }
  },
  editVertexThresholdFeet: 3.5,
  geometryServiceUrl: "https://utility.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer",
  labelPlacementPrecision: 60,
  layers: {
    fields: {
      minLabelScale: 38e3,
      minScale: 25e4
    }
  },
  minimumAcreage: .25,
  pointTolerance: .001,
  minVertexNudgeScale: 25e4,
  sampling: {
    cellEdgeBuffer: .15,
    maxGridCellCount: 1600,
    minGridCellCount: 4,
    partialGridCellLimit: .5,
    randomGridSiteDistance: .5,
    randomMaxAttempts: 100
  },
  symbols: {
    draw: {
      edit: {
        ghostLine: e.createSimpleLineSymbolJSON([0, 0, 0], 1),
        ghostVertex: e.createSimpleMarkerSymbolJSON([255, 255, 255, 64], 6, "esriSMSCircle", 0, 0, [0, 0, 0, 64]),
        selectedVertex: e.createSimpleMarkerSymbolJSON([44, 238, 0], 9, "esriSMSCircle", 0, 0, [20, 100, 0]),
        vertex: e.createSimpleMarkerSymbolJSON([128, 128, 128], 9, "esriSMSCircle", 0, 0, [255, 255, 255])
      },
      nonFieldFeature: {
        point: e.createSimpleMarkerSymbolJSON([191, 255, 0, 102], 9, "esriSMSCircle", 0, 0, [255, 255, 255], 1),
        polygon: e.createSimpleFillSymbolJSON([191, 255, 0, 102], [255, 255, 255], 3),
        polyline: e.createSimpleLineSymbolJSON([255, 200, 0], 3),
        highlight: {
          point: e.createSimpleMarkerSymbolJSON([255, 200, 0, 102], 9, "esriSMSCircle", 0, 0, [60, 60, 0], 1),
          polygon: e.createSimpleFillSymbolJSON([255, 200, 0, 102], [60, 60, 0], 3),
          polyline: e.createSimpleLineSymbolJSON([255, 200, 0], 3)
        },
        invalid: {
          polygon: e.createSimpleFillSymbolJSON([255, 0, 0, 102], [255, 0, 0], 3, "esriSLSDash"),
          polyline: e.createSimpleLineSymbolJSON([255, 0, 0], 3, "esriSLSDash")
        }
      },
      measure: {
        line: e.createSimpleLineSymbolJSON([255, 255, 255, 100], 2)
      },
      nudge: {
        fill: e.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 140, 0], 3),
        label: e.createTextSymbolJSON([200, 200, 200], "Arial", 14, 0, 30, "italic", "normal")
      },
      polygon: {
        fill: e.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 255, 255], 3),
        invalid: e.createSimpleFillSymbolJSON([255, 0, 0, 102], [255, 0, 0], 3, "esriSLSDash")
      },
      reshape: {
        line: e.createSimpleLineSymbolJSON([255, 0, 0], 2)
      }
    },
    label: {
      text: e.createTextSymbolJSON([255, 255, 255], "Arial", 12, 0, 0),
      locationOffset: {
        x: 0,
        y: -9
      }
    },
    measure: {
      area: {
        fill: e.createSimpleFillSymbolJSON([0, 0, 0, 85], [29, 170, 239], 2),
        invalid: e.createSimpleFillSymbolJSON([0, 0, 0, 85], [255, 0, 0], 2, "esriSLSDash")
      },
      length: {
        line: e.createSimpleLineSymbolJSON([29, 170, 239], 2)
      },
      location: {
        marker: e.createPictureMarkerSymbolJSON("iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAABKklEQVR42mNgQAIiAS4OwgGuC4QDXD6IBLr+R8YgMZAcSA0DNiAc4DxBKsbrv2Fb7H+b2en/nZbmoGCQGEgOpAakFkWzUIBLgWyiz3/7BVkYGi0nhoKx1eSI/7azE8BqQGpBepBsd3lgNS0VQzOyATBsMz3mP0gtSA/C70A/omv0W136v3DPxP/Zaxv+u85IQDEEJC8e5v4fpwGdxxf///Lr238Y+Pzz6/+WXVOJMwBkKy4Acg3MAJAerAYceXwRpwGH7p4ibMCFl7dxGnDuyVU6uIDiMCA2FvAaQEw6IGgArpQ4agAVDLCaFIbFAH+XC6qFIQQNsJ4a+d9xSfZ/kFqQHrgBAgEOArgMwaUZpAelWMNlCFGa8RlCtGZchpCkGZshJGtGN4SQZgAnEeyRsAhXAQAAAABJRU5ErkJggg==", !0, "image/png", 12, 22, 0, 18)
      }
    },
    sampling: {
      clippedGrid: {
        default: e.createSimpleFillSymbolJSON([0, 0, 0, 0], [128, 0, 0], .5),
        hover: e.createSimpleFillSymbolJSON([255, 255, 255, 50], [128, 0, 0], 2)
      },
      grid: e.createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 255, 0], 2),
      selectionBox: e.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 255, 255], 2)
    },
    search: {
      pin: e.createPictureMarkerSymbolJSON("https://js.arcgis.com/3.21/esri/dijit/Search/images/search-pointer.png", !1, "image/png", 27, 27, 6.75, 13.5),
      plss: e.createSimpleFillSymbolJSON([0, 0, 0, 85], [29, 170, 239], 2)
    },
    zones: {
      active: {
        classified: e.createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 255, 255], 3),
        normal: e.createSimpleFillSymbolJSON([255, 255, 0, 128], [255, 140, 0], 3)
      },
      create: {
        fill: e.createSimpleFillSymbolJSON([255, 0, 0, 85], [255, 0, 0], 2),
        invalid: e.createSimpleFillSymbolJSON([255, 0, 0, 102], [255, 0, 0], 2, "esriSLSDash"),
        line: e.createSimpleLineSymbolJSON([255, 0, 0], 2)
      },
      default: e.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 255, 255], 3),
      edit: e.createSimpleFillSymbolJSON([226, 104, 22, 102], [255, 140, 0], 3),
      normal: {
        noData: e.createSimpleFillSymbolJSON([215, 215, 215, 64], [255, 140, 0], 3),
        withData: e.createSimpleFillSymbolJSON([226, 104, 22], [255, 140, 0], 3, "esriSLSSolid", "esriSFSBackwardDiagonal"),
        withDataImage: e.createPictureFillSymbolJSON(r, !0, "image/png", 10, 10, .7, .7, [255, 140, 0], 3, "esriSLSSolid")
      },
      selectedForCopy: {
        classified: e.createSimpleFillSymbolJSON([0, 255, 255, 225], [0, 255, 255], 4, "esriSLSSolid", "esriSFSCross"),
        normal: e.createSimpleFillSymbolJSON([255, 140, 0, 128], [255, 255, 0], 4)
      },
      scoutingPoint: {
        normal: e.createSimpleMarkerSymbolJSON([73, 142, 226], 9, "esriSMSCircle", 0, 0, [255, 255, 255]),
        active: e.createSimpleMarkerSymbolJSON([143, 166, 26], 9, "esriSMSCircle", 0, 0, [255, 255, 255])
      }
    }
  }
},
    debounce = function debounce(e, r) {
  var i;
  return function () {
    var _arguments = arguments,
        _this = this;

    var functionCall = function functionCall() {
      return e.apply(_this, _arguments);
    };

    clearTimeout(i), i = setTimeout(functionCall, r);
  };
},
    debouncePromise = function debouncePromise(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var i,
      t,
      l = [];

  var _flush = function _flush() {
    var r = i;
    clearTimeout(t), e.apply(void 0, l).then(function (e) {
      return r.resolve(e);
    }, function (e) {
      return r.reject(e);
    }), l = [], i = null;
  };

  return {
    call: function call() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      return i ? clearTimeout(t) : i = function () {
        var e = {};
        return e.promise = new Promise(function (r, i) {
          e.resolve = r, e.reject = i;
        }), e;
      }(), l = e, t = setTimeout(_flush.bind(void 0), r), i.promise;
    },
    cancel: function cancel() {
      return clearTimeout(t);
    }
  };
},
    isIE = function isIE() {
  return (
    /*@cc_on!@*/
    null != document.documentMode
  );
},
    isNotNothing = function isNotNothing(e) {
  return null != e && "" !== e;
},
    isNumeric = function isNumeric(e) {
  try {
    var _r = parseFloat(e);

    return !isNaN(e) && isNotNothing(_r) && !isNaN(_r) && isFinite(_r);
  } catch (r) {
    return !1;
  }
},
    normalizeGuid = function normalizeGuid(e) {
  return e ? e.replace(/{|}/g, "").toLowerCase() : e;
},
    flattenTree = function flattenTree(e, r) {
  if (null == e || e === {}) return [];
  var i = e[r];
  null != i && i !== {} || (i = []);
  return [Object.assign({}, e)].concat(_toConsumableArray(i.flatMap(function (e) {
    return flattenTree(e, r);
  })));
},
    l = Object.freeze({
  __proto__: null,
  base64ToBlob: function base64ToBlob(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
    var t = atob(e),
        l = [];

    for (var _a = 0; _a < t.length; _a += i) {
      var _e = t.slice(_a, _a + i),
          _r2 = new Array(_e.length);

      for (var _i = 0; _i < _e.length; _i++) {
        _r2[_i] = _e.charCodeAt(_i);
      }

      l.push(new Uint8Array(_r2));
    }

    return new Blob(l, {
      type: r
    });
  },
  base64ImageToBase64string: function base64ImageToBase64string(e) {
    return e.split(",").pop();
  },
  base64StringToBase64Image: function base64StringToBase64Image(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "jpeg";
    var i = "data:image/";
    return e.includes(i) ? e : "data:image/".concat(r, ";base64, ").concat(e);
  },
  debounce: debounce,
  debouncePromise: debouncePromise,
  fileToBase64: function fileToBase64(e) {
    return new Promise(function (r) {
      var i = new FileReader();
      i.readAsDataURL(e), i.addEventListener("load", function () {
        r(i.result);
      }, !1);
    });
  },
  fileToXML: function fileToXML(e) {
    return new Promise(function (r) {
      var i = new FileReader();
      i.readAsText(e), i.addEventListener("load", function () {
        r(i.result);
      }, !1);
    });
  },
  fileIsSvgMarkup: function fileIsSvgMarkup(e) {
    return e.includes("<svg");
  },
  getFailedActionString: function getFailedActionString() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return "Failed to process action ".concat(e || "");
  },
  isEmptyArray: function isEmptyArray(e, r) {
    return Array.isArray(e[r]) && 0 !== Object.keys(e[r][0]).length;
  },
  isEmptyObject: function isEmptyObject(e) {
    return 0 === Object.getOwnPropertyNames(e).length;
  },
  isIE: isIE,
  isInputTheActiveElement: function isInputTheActiveElement() {
    return document.activeElement && ["password", "text", "textarea"].includes(String(document.activeElement.type).toLowerCase());
  },
  isNothing: function isNothing(e) {
    return null == e || "" === e;
  },
  isNotNothing: isNotNothing,
  isNumeric: isNumeric,
  normalizeGuid: normalizeGuid,
  parseOrgLevelList: function parseOrgLevelList() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var r = arguments.length > 1 ? arguments[1] : undefined;
    var i = arguments.length > 2 ? arguments[2] : undefined;
    var t = arguments.length > 3 ? arguments[3] : undefined;
    var l = t || e.find(function (_ref) {
      var e = _ref.orgLevelParents;
      return 0 === e.length;
    }) || {};
    return e.map(function (e) {
      if (e[r] instanceof Array) {
        var _t = e[r].filter(function (e) {
          return e !== l.orgLevelName;
        }).reduce(function (e, r) {
          return ("" !== e ? e + i : e) + r;
        }, "");

        return _objectSpread(_objectSpread({}, e), {}, {
          parentsSummary: _t
        });
      }

      return null;
    });
  },
  processFileDialog: function processFileDialog(e) {
    var r = e.files,
        i = Array.from(r),
        t = i.filter(function (r) {
      return function (e, r) {
        var i = !1,
            t = r.toString().toLowerCase().split(",");

        for (var _l = 0; _l < t.length; _l++) {
          if (t[_l] = t[_l].toString().replace(".", ""), e.toString().toLowerCase().indexOf(t[_l]) > -1) {
            i = !0;
            break;
          }
        }

        return i;
      }(r.name, e.fileType);
    });
    return t.length !== i.length && alert("File Type is Invalid"), Promise.all(t.map(function (r) {
      return function (e, r) {
        return new Promise(function (i) {
          var t = new window.FileReader();
          t.onload = function (e) {
            var t = e.target.result;
            t.indexOf(",") > -1 && r.removeHeaderFromString && (t = t.toString().substring(t.indexOf(",") + 1)), i(t);
          }, t.onloadstart = function (e) {
            r.fileStartCallback && r.fileStartCallback(e);
          }, t.onprogress = function (e) {
            r.fileProgressCallback && r.fileProgressCallback(e);
          }, t.readAsDataURL(e);
        });
      }(r, e);
    }));
  },
  flattenTree: flattenTree
}),
    a = i({
  insensitive: !0
}),
    o = Object.freeze({
  __proto__: null,
  sortValues: function sortValues(e, r) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ASC";
    var t = /[^a-zA-Z]/g,
        l = /[^0-9]/g;
    return e.sort(function (e, i) {
      var a = e[r],
          o = i[r],
          s = a.toString().toLowerCase().replace(t, "z"),
          n = o.toString().toLowerCase().replace(t, "z");

      if (s === n) {
        var _e2 = parseInt(a.replace(l, "z"), 10),
            _r3 = parseInt(o.replace(l, "z"), 10);

        return _e2 === _r3 ? 0 : _e2 > _r3 ? 1 : -1;
      }

      return s > n ? 1 : -1;
    }), "ASC" !== i && e.reverse(), e;
  },
  naturalCompare: function naturalCompare(e, r) {
    return a(e, r);
  }
}),
    s = (window.process_env || {}).AGS_BASE_URL || "",
    n = {
  baseUrl: s,
  geocode: {
    addressParam: "address",
    url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"
  },
  services: {
    geometryServiceUrl: "".concat(s).concat((window.process_env || {}).AGS_SERVICE_ROOT_PATH, "/Utilities/Geometry/GeometryServer"),
    sampleSites: {
      layerDefinition: {
        geometryType: "esriGeometryPoint",
        objectIdField: "OBJECTID",
        fields: [{
          name: "OBJECTID",
          type: "esriFieldTypeOID",
          alias: "ObjectID"
        }, {
          name: "AgEventGeneralGuid",
          type: "esriFieldTypeString",
          alias: "AgEventGeneralGuid"
        }, {
          name: "DepthID",
          type: "esriFieldTypeString",
          alias: "DepthID"
        }, {
          name: "SampleID",
          type: "esriFieldTypeString",
          alias: "SampleID"
        }, {
          name: "SequenceID",
          type: "esriFieldTypeString",
          alias: "SequenceID"
        }, {
          name: "Matched",
          type: "esriFieldTypeInteger",
          alias: "Matched"
        }, {
          name: "UUID",
          type: "esriFieldTypeString",
          alias: "UUID"
        }, {
          name: "Value",
          type: "esriFieldTypeString",
          alias: "Value"
        }]
      }
    }
  }
};

var c;
!function (e) {
  e.WebMercator = "webMercator", e.Wgs84 = "wgs84";
}(c || (c = {}));
export { c as A, t as T, l as a, isNumeric as b, debouncePromise as c, debounce as d, n as e, flattenTree as f, isIE as i, normalizeGuid as n, o as s };